interface FactOnlyRowProps {
  label: string
  weeklyFact: string
  monthFact: string
}

export function FactOnlyRow({ label, weeklyFact, monthFact }: FactOnlyRowProps) {
  return (
    <tr className="border-b border-border hover:bg-muted/30 transition-colors">
      <td className="p-3 pl-6 text-sm">{label}</td>
      <td className="p-3 text-right font-mono text-sm text-muted-foreground">-</td>
      <td className="p-3 text-right font-mono text-sm font-semibold">{weeklyFact}</td>
      <td className="p-3 text-right font-mono text-sm text-muted-foreground">-</td>
      <td className="p-3 text-right font-mono text-sm font-semibold">{monthFact}</td>
      <td className="p-3 text-center text-muted-foreground">-</td>
    </tr>
  )
}
